"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagedTableFieldContext = void 0;
const react_1 = require("react");
exports.PagedTableFieldContext = react_1.createContext({
    page: 0,
    rowsPerPage: 5,
});
//# sourceMappingURL=paged-table-field-context.js.map